<template>
  <div>
    <gTimeComp
      :sTime.sync="startTime"
      :eTime.sync="endTime"
      type="today"
      @click="timeChange"
    ></gTimeComp>
    <gLine></gLine>
    <div class="p-24 box">
      <div class="top p-tb-10 m-b-20">
        <div>{{whichDay}}提成</div>
        <div class="">
          <div class="po-r">
            <gNewImg
              src="moneyCircle.png"
              which="clock"
              size="150"
            ></gNewImg>
            <div class="po-a 
              bold-900 cl-theme ft-32 circle_txt">{{all_total.totalpersume | toMoney}}</div>
          </div>
        </div>
        <div>
          <span class="cl-33">基本提成 </span>
          <span class="cl-theme ft-32 m-r-40 bold-900">{{all_total.basepersume | toMoney}}</span>
          <span class="cl-33">阶梯提成 </span>
          <span class="cl-theme ft-32 bold-900">{{all_total.steppersume | toMoney}}</span>
        </div>
      </div>

      <div
        class="main w-block"
        @click="toDetail('clock')"
      >
        <div class="bold-500 m-t-10">做钟提成</div>
        <div class="f-bt p-l-70 m-tb-10 item ">
          <div class="inner_item">
            <div class="num">{{persume_clock_total.count || 0}}</div>
            <div>上钟单数</div>
          </div>
          <div class="inner_item">
            <div class="num">{{persume_clock_total.steppersume | toMoney}}</div>
            <div>阶梯提成</div>
          </div>
          <div class="inner_item">
            <div class="num">
              {{persume_clock_total.basepersume | toMoney}}
            </div>
            <div>基本提成</div>
          </div>
          <gNewImg
            class="m-r-40"
            src="pullRight.png"
            size="6"
          ></gNewImg>
        </div>
      </div>

      <div
        class="main w-block"
        @click="toDetail('project')"
      >
        <div class="bold-500 m-t-10">项目推销提成</div>
        <div class="f-bt p-l-70 m-tb-10 item ">
          <div class="inner_item">
            <div class="num">{{persume_project_total.amount | toMoney}}</div>
            <div>推销金额</div>
          </div>
          <div class="inner_item">
            <div class="num">{{persume_project_total.count || 0}}</div>
            <div>推销单数</div>
          </div>
          <div class="inner_item">
            <div class="num">
              {{persume_project_total.salepersume | toMoney}}
            </div>
            <div>推销提成</div>
          </div>
          <gNewImg
            class="m-r-40"
            src="pullRight.png"
            size="6"
          ></gNewImg>
        </div>
      </div>
      <div
        class="main w-block"
        @click="toDetail('goods')"
      >
        <div class="bold-500 m-t-10">商品推销提成</div>
        <div class="f-bt p-l-70 m-tb-10 item ">
          <div class="inner_item">
            <div class="num">{{persume_goods_total.amount | toMoney}}</div>
            <div>推销金额</div>
          </div>
          <div class="inner_item">
            <div class="num">{{persume_goods_total.count || 0}}</div>
            <div>推销单数</div>
          </div>
          <div class="inner_item">
            <div class="num">
              {{persume_goods_total.salepersume | toMoney}}
            </div>
            <div>推销提成</div>
          </div>
          <gNewImg
            class="m-r-40"
            src="pullRight.png"
            size="6"
          ></gNewImg>
        </div>
      </div>
      <div
        class="main w-block"
        @click="toDetail('sale')"
      >
        <div class="bold-500 m-t-10">售卡充值提成</div>
        <div class="f-bt p-l-70 m-tb-10 item ">
          <div class="inner_item">
            <div class="num">{{persume_card_total.count || 0}}</div>
            <div>售卡单数</div>
          </div>
          <div class="inner_item">
            <div class="num">{{persume_card_total.steppersume | toMoney}}</div>
            <div>阶梯提成</div>
          </div>
          <div class="inner_item">
            <div class="num">
              {{persume_card_total.basepersume | toMoney}}
            </div>
            <div>基本提成</div>
          </div>
          <gNewImg
            class="m-r-40"
            src="pullRight.png"
            size="6"
          ></gNewImg>
        </div>
      </div>
    </div>

    <gLogoBottom></gLogoBottom>
  </div>
</template>

<script>
import { getpersumestatistics, getclockstatistics, getjishicode, jishiDuty } from "@/api/Jishi";
export default {
  name: "JiShiCommissionDetail",
  props: {

  },
  data() {
    return {
      endTime: '',
      startTime: '',
      aData: {},
      all_total: {},
      persume_clock_total: {}, // 做钟提成
      persume_project_total: {}, // 项目推销提成
      persume_goods_total: {}, // 商品推销提成
      persume_card_total: {},// 售卡充值提成
      whichDay: '',

    };
  },
  components: {

  },
  created() {
    // setTimeout(() => {
    //   this.persume_clock_total.basepersume = 123
    //   this.$forceUpdate();
    // }, 3000);

  },
  mounted() {
    console.log(`%c this.$router ***** 168行 ~/test/testProject/mobile-template/src/newViews/technician/commissionDetail.vue 16:59:46}`, "background-image:color:transparent;color:red;font-size:1.2em");
    console.log(this.$router);
    console.log(`%c this.$route ***** 170行 ~/test/testProject/mobile-template/src/newViews/technician/commissionDetail.vue 17:00:18}`, "background-image:color:transparent;color:green;font-size:1.2em");
    console.log(this.$route);
    // this.$nextTick(() => {
    //   document.title = "哈哈"
    // })

  },
  methods: {
    toDetail(str) {
      getpersumestatistics().then(res=>{


      })
      // this.$router.push(
      //   { path: '/technician/technicianSubDetail', query: { which: str } },
      // );
    },
    timeChange(nowTitle) {
      if (nowTitle === '自定义') {
        this.whichDay = this.startTime + '至' + this.endTime
      } else {
        this.whichDay = nowTitle;
      }
      calcHttp(this, this.startTime, this.endTime).then(res => {
        this.aData = res.data;
        this.all_total = this.aData.persume_total || {};
        this.persume_clock_total = this.aData.persume_clock_total;
        this.persume_project_total = this.aData.persume_project_total || {};
        this.persume_goods_total = this.aData.persume_goods_total || {};
        this.persume_card_total = this.aData.persume_card_total || {};
      })
    },

  }
};
</script>
<style scoped lang='scss'>
.box {
  background: #fff;
  font-size: 24px;
  color: #666;
  .top {
    text-align: center;
    .circle_txt {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    border-bottom: 1px solid #ebedf0;
  }
  .main {
    border-bottom: 1px solid #ebedf0;
    .item {
      height: 100px;
      padding: 10px 0;
      margin-left: 50px;
      text-align: center;
      box-sizing: border-box;
      .inner_item {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
    .num {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
}
</style>